import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  ErrorDialogComponent,
  LoaderComponent,
  ToasterComponent,
} from './components';
import { MaterialModule } from './modules';
import { SetImagePathDirective } from '@shared/directives';

@NgModule({
  declarations: [LoaderComponent, ErrorDialogComponent, ToasterComponent],
  imports: [CommonModule, MaterialModule, SetImagePathDirective],
  exports: [LoaderComponent, ErrorDialogComponent, ToasterComponent],
  providers: [],
})
export class CoreModule {}
